import { Component, Input, OnInit } from '@angular/core';
import { ReceiptDetail } from 'src/app/classes/receiptDetail';
import { TotalsInformation } from 'src/app/classes/totalsInformation';

@Component({
  selector: 'app-price-adjustments',
  templateUrl: './price-adjustments.component.html',
  styleUrls: ['./price-adjustments.component.scss'],
})
export class PriceAdjustmentsComponent implements OnInit {

  @Input()
  public priceAdjustment: ReceiptDetail | null;

  @Input()
  public totalsInformation: TotalsInformation;

  @Input()
  public hideAmounts: boolean = false;

  @Input()
  public show: boolean = false;

  public deductionsPresent = false;
  public addictionsPresent = false;

  constructor() { }

  ngOnInit() {
    if(this.priceAdjustment && this.priceAdjustment.appliedAdjustments) {
      this.deductionsPresent = !!this.priceAdjustment.appliedAdjustments.find(x => x.isDeduction);
      this.addictionsPresent = !!this.priceAdjustment.appliedAdjustments.find(x => !x.isDeduction);
    }
  }

}
